export default __webpack_public_path__ + "static/media/js_kurs.1006f8f3.jpg";